module.exports = __webpack_public_path__ + "static/img/shizi.5037040c.png";